/* eslint react/jsx-props-no-spreading: 0 */
/* eslint max-classes-per-file: 0 */

import React from 'react';
import ConsumerMenuItems from './ConsumerMenu';
import PublisherMenuItems from './PublisherMenu';
import AuditorMenuItems from './AuditorMenu';
import CustomSideMenu from './CustomSideMenu';

export const withSideMenuConsumer = (Component) => class SideMenuConsumer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.childContainer = {};
  }

  render() {
    const {
      direction, user, userData, history, location, getAnalyticsService, // eslint-disable-line react/prop-types
    } = this.props;

    return (
      <CustomSideMenu
        direction={direction}
        user={user}
        userData={userData}
        history={history}
        location={location}
        getAnalyticsService={getAnalyticsService}
        childContainer={this.childContainer}
        getItems={ConsumerMenuItems}
      >
        <Component ref={(comp) => { this.childContainer.comp = comp; }} {...this.props} />
      </CustomSideMenu>
    );
  }
};

export const withSideMenuPublisher = (Component) => class SideMenuConsumer extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.childContainer = {};
  }

  render() {
    const {
      direction, user, userData, history, location, getAnalyticsService, // eslint-disable-line react/prop-types
    } = this.props;

    return (
      <CustomSideMenu
        direction={direction}
        user={user}
        userData={userData}
        history={history}
        location={location}
        getAnalyticsService={getAnalyticsService}
        childContainer={this.childContainer}
        getItems={PublisherMenuItems}
      >
        <Component ref={(comp) => { this.childContainer.comp = comp; }} {...this.props} />
      </CustomSideMenu>
    );
  }
};

export const withSideMenuAuditor = (Component) => class SideMenuAuditor extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.childContainer = {};
  }

  render() {
    const {
      direction, user, userData, history, location, getAnalyticsService, // eslint-disable-line react/prop-types
    } = this.props;

    return (
      <CustomSideMenu
        direction={direction}
        user={user}
        userData={userData}
        history={history}
        location={location}
        getAnalyticsService={getAnalyticsService}
        childContainer={this.childContainer}
        getItems={AuditorMenuItems}
      >
        <Component ref={(comp) => { this.childContainer.comp = comp; }} {...this.props} />
      </CustomSideMenu>
    );
  }
};
